import { useEffect, useState } from "react";

export type UseInputValidator = (
  val: string,
) => { valid: true } | { valid: false; message?: string };

interface UseInputOptions {
  value: string;
  error?: string;
  regex?: RegExp;
  validate?: UseInputValidator;
}

export const useInput = ({
  validate,
  error: optError,
  value: optValue,
  regex,
}: UseInputOptions): {
  value?: string;
  error?: string;
  props: React.HTMLProps<HTMLInputElement>;
} => {
  const [value, setValue] = useState<string | undefined>(optValue);
  const [error, setError] = useState(optError);

  useEffect(() => {
    if (!regex || !value) {
      return;
    }

    const valid = regex.test(value);
    if (!valid) {
      setError("Invalid input format");
      return;
    }

    setError(undefined);
  }, [regex, value]);

  useEffect(() => {
    if (!validate || !value) {
      return;
    }

    const res = validate(value);
    if (!res.valid) {
      setError(res.message ?? "Invalid input format");
      return;
    }

    setError(undefined);
  }, [validate, value]);

  useEffect(() => {
    setError(optError);
  }, [optError]);

  return {
    value,
    error,
    props: { value: value ?? undefined, onChange: (e) => setValue(e.currentTarget.value) },
  };
};
